import React from 'react'
import { View } from 'react-native'
import { BottomSheet } from '@components/BottomSheet'
import { Text } from '@src/components/base'
import { useGoBack } from '@src/utils/navigation'
import { StyleService, useStyleSheet } from '@src/style/service'
import { ChooseMainChartSection } from './ChooseMainChartSection'

export const CustomizeHomeModal = () => {
  const goBack = useGoBack()
  const styles = useStyleSheet(themedStyle)

  const onDoneButtonPress = () => {
    goBack()
  }

  return (
    <BottomSheet
      header="Customize the Home Screen"
      primaryButton={{ text: 'Done', onPress: onDoneButtonPress }}
    >
      <View style={styles.sectionDescription}>
        <Text type="large" style={styles.sectionText}>
          Choose how to visualize your data in the home screen.
        </Text>
      </View>
      <ChooseMainChartSection />
    </BottomSheet>
  )
}

const themedStyle = StyleService.create({
  sectionDescription: {
    marginBottom: 36,
    marginHorizontal: 36,
  },
  sectionText: {
    textAlign: 'center',
  },
})
